import { render, staticRenderFns } from "./UnifiedControlElement.vue?vue&type=template&id=3aace766&lang=pug&"
import script from "./UnifiedControlElement.vue?vue&type=script&lang=js&"
export * from "./UnifiedControlElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports